export default {
  todaysWins(state) {
    return state.todaysWins;
  },

  todaysBigTask(state) {
    return state.todaysBigTask;
  },

  todaysSmallTasks(state) {
    return state.todaysSmallTasks;
  }

};
